// /api/devops/doc-checks client. Team-shared checkbox state for the
// embedded docs viewer's GFM task-lists. Read = list of ticked ids for
// one doc; write = single (doc, id, checked) triple.
//
// GET returns Set<string> of checkbox_ids currently ticked. Failure is
// swallowed (empty set) — the viewer degrades to "nothing ticked" rather
// than blocking the render.
import { api } from "./_client";

interface DocChecksResponse {
  checked_ids: string[];
}

export async function readCheckedIds(docPath: string): Promise<Set<string>> {
  try {
    const path = `/api/devops/doc-checks?doc_path=${encodeURIComponent(docPath)}`;
    const res = await api<DocChecksResponse>("GET", path);
    return new Set(res.checked_ids ?? []);
  } catch (err) {
    console.warn("doc-checks read failed", err);
    return new Set();
  }
}

export async function writeChecked(
  docPath: string,
  checkboxId: string,
  checked: boolean,
): Promise<void> {
  await api<void>("PUT", "/api/devops/doc-checks", {
    doc_path: docPath,
    checkbox_id: checkboxId,
    checked,
  });
}
